module.exports = __webpack_public_path__ + "img/help-icon.fe3212be.png";